import { axiosClient } from './AxiosClient'
import { baseURL } from '../Network/Config'
import axios from 'axios'

// id 1 - Term and Condition
// id 2 - Contact
// id 3 - about

function getContent(contentId, callback, errorCallback){
    let url = "/content/" + contentId
    
    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function updateContent(contentId, content, callback, errorCallback){
    let url = baseURL + "/content/" + contentId

    const body = {
        "content": content
    }
    let bodyJson = JSON.stringify(body)

    axios.put(url, bodyJson,{
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("access_token")
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
    
}

function acceptTerm(callback, errorCallback){
    let url = "/account/accept_term"
    axiosClient.post(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewAbout(callback, errorCallback){
    let url = "/content/view/about"
    axiosClient.get(url, {
        params: {
            building_id: localStorage.getItem('building_id')
        }
    })
    .then((response)=>{
        callback(response.data.about_us)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function editAbout(newAbout, callback, errorCallback){
    let url = "/content/edit/about"
    var bodyForm = new FormData()
    bodyForm.append("about_us", newAbout)
    bodyForm.append("building_id", localStorage.getItem('building_id'))

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data.about_us)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewContact(callback, errorCallback){
    let url = "/content/view/contact"
    axiosClient.get(url, {
        params: {
            building_id: localStorage.getItem('building_id')
        }
    })
    .then((response)=>{
        callback(response.data.contact_us)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function editContact(newContact, callback, errorCallback){
    let url = "/content/edit/contact"
    var bodyForm = new FormData()
    bodyForm.append("contact_us", newContact)
    bodyForm.append("building_id", localStorage.getItem('building_id'))

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data.contact_us)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { getContent, updateContent, acceptTerm, viewAbout, editAbout, viewContact, editContact }